<script lang="ts">
    import { getContext, onDestroy, setContext } from 'svelte'
    import { derived as sderived, writable } from 'svelte/store'
    import type { Readable, Writable } from 'svelte/store'

    import Icon from '@iconify/svelte'

    import { iconExclamationTriangle } from 'hydria/icons'
    import { gettext as _ } from 'hydria/services/gettext'
    import { spath } from 'hydria/svelte_helpers'

    import type { IAddress } from 'wdom/services/contacts'
    import { Breadcrumb } from 'breadcrumb'

    import type { User, UserHandler } from './user'

    import AddressesBlock from './AddressBlock.svelte'
    import CommentBlock from './CommentBlock.svelte'
    import DelegationBlock from './DelegationBlock.svelte'
    import SubaccountBlock from './SubaccountBlock.svelte'
    import InfoBlock from './InfoBlock.svelte'
    import InteractionBlock from './InteractionBlock.svelte'
    import MiscBlock from './MiscBlock.svelte'
    import ModificationLogBlock from './ModificationLogBlock.svelte'
    import StatusBlock from './StatusBlock.svelte'
    import TwofaBlock from './TwofaBlock.svelte'
    import ZonesBlock from './ZoneBlock.svelte'

    const userh = getContext('User') as UserHandler

    const status = sderived(userh.status, ($status) => $status)

    const user: Readable<User> = sderived(userh.userWritable, ($v) => $v)

    const selectedAddress: Writable<IAddress | null> = writable(null)
    setContext('selectedAddress', selectedAddress)

    const unsubs: any[] = []
    onDestroy(() => {
        for (const unsub of unsubs) unsub.unsubscribe != null ? unsub.unsubscribe() : unsub()
    })

    unsubs.push(
        userh.addresses.subscribe((addresses) => {
            if (!addresses || !addresses.length) $selectedAddress = null
            if (!$selectedAddress && addresses && addresses.length) $selectedAddress = addresses[0]
        }),
    )

    const crumbs = sderived(status, ($status) => [
        { txt: $_('Users'), url: spath('/wdom-users') },
        {
            txt: $status == 'ready' ? $user.email : $status == 'loading' ? '…' : iconExclamationTriangle,
            html: $status != 'ready' && $status != 'loading',
        },
    ])
</script>

<Breadcrumb {crumbs} />

{#if $status == 'not-found' || $status == 'error'}
    <div class="alert alert-danger">
        <Icon inline icon="fa:exclamation-triangle" />
        {#if $status == 'not-found'}
            {$_('The requested document does not exist.')}
        {:else}
            {$_('An error occured. Please try again in a moment.')}
        {/if}
    </div>
{:else}
    <div class="d-grid gap-4">
        <div class="row">
            <div class="col-sm-6 col-md-6 col-lg-6">
                <AddressesBlock />
            </div>
            <div class="col-sm-6 col-md-6 col-lg-6">
                <InfoBlock />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-md-6 col-lg-6 d-grid gap-4">
                <StatusBlock />
                <TwofaBlock />
            </div>
            <div class="col-sm-6 col-md-6 col-lg-6 d-grid gap-4">
                <MiscBlock />
                <ZonesBlock />
                <SubaccountBlock />
                <DelegationBlock />
            </div>
        </div>
        <InteractionBlock />
        <CommentBlock />
        <ModificationLogBlock />
    </div>
{/if}
